export default "__VITE_ASSET__Beiow$ZE__"